import React from 'react'

const PioneersCard = ({
  paragraph,
  user,
  company,
  username,
  jobpost,
  companysize,
}) => {
  return (
    <div className="flex h-full min-h-[350px] flex-col justify-between rounded-md border border-black border-opacity-[6%] p-4 shadow-card-shadow sm:min-h-[481px] sm:p-6 md:min-h-[400px] xl:min-h-[337px]">
      <p className="text-xl font-medium leading-[128%] tracking-[-0.84px] text-night-black sm:text-[28px]">
        {paragraph}
      </p>
      <div className="flex items-center justify-between pt-6 sm:pt-12">
        <div className="flex items-center gap-3 max-[450px]:flex-col max-[450px]:items-start">
          <img
            className="w-[40px] sm:w-[60px]"
            src={user}
            alt="ashley"
          />
          <div>
            <p className="text-lg font-semibold tracking-[-0.74px] text-night-black sm:text-2xl">
              {username}
            </p>
            <p className="text-base font-medium leading-[120%] tracking-[-0.56px] text-night-black sm:text-lg sm:leading-[150%]">
              {jobpost}
            </p>
          </div>
        </div>
        <div className="ms-auto">
          {company && (
            <img
              className={companysize}
              src={company}
              alt="sunday"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default PioneersCard
